import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Card, Container, Table, CardFooter } from "reactstrap";

import { helper } from "lib/helper";
import experienceModel from "models/experience.model";
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper"; // Import your generic filter function

const ExperienceReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("1");
  const { id } = useParams();

  const navigate = useNavigate();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [reportData, setReportData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [searchQuery, setSearchQuery] = useState("");

  const getExperienceReports = async () => {
    setIsLoading(true);
    await experienceModel
      .experienceReports(id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setReportData(result?.data?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  console.log(reportData, "+++++++++++++++  reportData");

  // Use your filterItems function to filter data based on the search query
  const filteredDataList = filterItems(reportData, searchQuery, [
    "username",
    "mob",
    "experienceType",
    "goods",
    "services",
    "audienceFor",
  ]);




  // Filter users based on search query
  const filteredUsers = filterItems(filteredDataList, searchQuery, [
    "firstName",
    "email",
    "mob",
  ]);


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page when pagination is clicked
  };

  const handleDeleteReport = (delId) => {
    helper.sweetalert
      .confirm(
        "Are You sure you want to delete  this data?",
        "info",
        true
      )
      .then((result) => {
        if (result.isConfirmed) {
          experienceModel.deleteReportData(delId).then((res) => {
            helper.sweetalert.toast(res?.data?.message);
            getExperienceReports();
          });
        }
      });
  };

  useEffect(() => {
    getExperienceReports();
  }, [location]);

  return (
    <Container className="pt-0">
      <Card className="shadow">
        {reportData?.length === 0 ? (
          <h3 className="text-center">No reports yet</h3>
        ) : (
          <>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">Reported by</th>
                  <th scope="col">Reasons</th>
                  <th scope="col">Issue</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {reportData?.map((item, index) => {
                  return (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item?.user?.firstName} {item?.user?.lastName} ({item?.user?.mobileNo})</td>
                      <td>{item.reason}</td>
                      <td>{item.issue}</td>
                      <td>
                        <Button color="danger" size="sm" onClick={() => handleDeleteReport(item._id)} >
                          <i className="fa-solid fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              <TablePagination
                totalPages={Math.ceil(reportData?.length / perPage)}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                pageUrl="/admin/users?"
              />
            </CardFooter>
          </>
        )}
      </Card>
    </Container>
  );
};

export default ExperienceReports;
